import { useEffect } from "react";

export const PressForm = () => {
   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: 'c5e315c3-9a4f-48f0-900a-a71a2debdb95',
               target: '#pressForm'
            })
         }
      });
   });

   return (
      <div className="footer-form press-form">
         <h1>Apply for Press Credentials</h1>
         <p>Fill out the form below if you’re interested in attending as an accredited Journalist</p>
         <div id="pressForm" />
      </div>
   )
}